const INVALID_CONFIGURED_URLS = new Set(["undefined", "null"]);

const normalizeBaseUrl = (value) => String(value || "").trim().replace(/\/+$/, "");

export const resolveBackendUrl = (options = {}) => {
  const configuredUrl = Object.prototype.hasOwnProperty.call(options, "configuredUrl")
    ? options.configuredUrl
    : process.env.REACT_APP_BACKEND_URL;
  const environment = options.environment || process.env.NODE_ENV;
  const origin = Object.prototype.hasOwnProperty.call(options, "origin")
    ? options.origin
    : typeof window !== "undefined"
      ? window.location.origin
      : "";
  const normalizedConfiguredUrl = normalizeBaseUrl(configuredUrl);
  if (normalizedConfiguredUrl && !INVALID_CONFIGURED_URLS.has(normalizedConfiguredUrl.toLowerCase())) {
    return normalizedConfiguredUrl;
  }

  if (environment === "development" || environment === "test") {
    return "http://127.0.0.1:8000";
  }

  return normalizeBaseUrl(origin);
};

export const backendUrl = resolveBackendUrl();
export const apiUrl = backendUrl ? `${backendUrl}/api` : "/api";
export const BACKEND_UNREACHABLE_MESSAGE = "Il servizio FullBook non è raggiungibile. Riprova tra poco.";
